module.exports = __webpack_public_path__ + "img/logo__24011701.6abd4621.svg";